
import { Component, Vue } from "vue-property-decorator";
import { readUserProfile } from "@/store/main/getters";
import {
  dispatchGetUserProfile,
  dispatchUnsubscribeFromBot,
  dispatchTelegramConnectPreview,
  dispatchUpdateUserAvatar,
  dispatchUpdateUserProfile,
  dispatchTelegramRebind,
} from "@/store/main/actions";
import { dispAuthFetch, dispatchGetUserBinaryTree } from "@/store/mlm/actions";
import ConnectMFAModal from "./ConnectMFAModal.vue";
import ChangeEmailModal from "@/components/Main/ChangeEmailModal.vue";
import ChangeTGModal from "./ChangeTGModal.vue";

import MyPromoCodes from "@/components/Main/Profile/MyPromoCodes.vue";
import ResidentRules from "./ResidentRules.vue";
import ClientBenefits from "./ClientBenefits.vue";
import EditIcon from "@/components/Icons/EditIcon.vue";
import AffiliateLink from "./AffiliateLink.vue";
import EditPassword from "@/components/Main/Profile/EditPassword.vue"
import {USER_ROLES} from '@/constants';
import { ITGConnectPreview } from '@/interfaces/index.js'
@Component({
  components: {
    MyPromoCodes,
    ChangeEmailModal,
    ConnectMFAModal,
    ChangeTGModal,
    ResidentRules,
    ClientBenefits,
    EditIcon,
    AffiliateLink,
    EditPassword
  },
})
export default class UserProfileEdit extends Vue {
  public imageFile: any = null;

  public avatarModalShow: boolean = false;
  public mfaModalShow: boolean = false;
  public financePasswordModalShow: boolean = false;

  public changeTGModalShow: boolean = false; // false; // 07.09.2026
  preview: ITGConnectPreview | null = null;
  // public telegramFormShow: boolean = false;
  public credentialsFormShow: boolean = false;
  public fName: any = "";
  public lName: any = "";
  public tgName: any = "";
  public showСontactInfo: boolean = false;
  public emailFormShow: boolean = false;
  public showResidentRules: boolean = false;

  public referralLink: string = "";
  public referralUserID: number|null = null;

  public telegramRebindLink: string = '';
  public telegramRebindLinkExpired: string = '';
  public loadingRebind: boolean = false;

  public disableTelegramBotLoading: boolean = false;
  public connectTelegramBotLoading: boolean = false;
  
  // --- computed --- //

  public get isResidentRole() {
    const role = this.userProfile?.role;
    return role === USER_ROLES.RESIDENT || role === USER_ROLES.RESIDENT_LIMITED;
  }

  public get isRegularUser() {
    const role = this.userProfile?.role;
    return role === USER_ROLES.OLD_USER || role === USER_ROLES.CLIENT;
  }
  
  public get shouldShowResidentRules() {
    return this.isResidentRole || (this.isRegularUser && this.showResidentRules);
    // const role = this.userProfile?.role;
    // return (
    //   role === "RESIDENT" || role === "RESIDENT_LIMITED" || (role !== "NEW_USER" && this.showResidentRules)
    // );
  }

  public get shouldShowClientBenefits() {
    // const role = this.userProfile?.role;
    // return (
    //   role !== "NEW_USER" && role !== "RESIDENT" && role !== "RESIDENT_LIMITED" && !this.showResidentRules
    // );
     return this.isRegularUser && !this.showResidentRules;
  }

  public formatDate(date: string): string {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}.${month}.${year}`;
    }

  public async mounted() {
    if (this.$route.query.token && this.$route.query.email) {
      this.emailFormShow = true;
    }

    // Восстанавливаем состояние showResidentRules из query параметра
    if (this.$route.query.showRules === "true") {
      this.showResidentRules = true;
    }

    // @ts-ignore
    this.showСontactInfo = this.userProfile?.show_contact_info
      ? this.userProfile?.show_contact_info
      : false;

    // получаем данные по рефералу
    this.getReferralData()
  }

  public async getReferralData() {
    if (this.userProfile) {
      if(this.userProfile.referral_link){this.referralLink = this.userProfile.referral_link;}
      if(this.userProfile.parent_id){this.referralUserID = this.userProfile.parent_id}
      // try {
      //   const response = (await dispatchGetUserBinaryTree(this.$store, {
      //     user: this.userProfile.id,
      //   })) as {
      //     referral_link: string;
      //     referral_user: { user_id: number; email: string };
      //   };
      //   if (response) {
      //     this.referralLink = response.referral_link;
      //     this.referralUserID = response.referral_user?.user_id;
      //   }
      // } catch (error) {
      //   console.log("no data referral ", error);
      // }
    }
  }

  public handleConnectMfa() {
    if (this.userProfile?.is_mfa_enabled === true) return;
    this.mfaModalShow = true;
  }

  public async handleCloseMfa() {
    this.mfaModalShow = false;
    await dispatchGetUserProfile(this.$store);
  }

  public handleOpenCredentials() {
    this.credentialsFormShow = true;
    this.fName = this.userProfile?.first_name;
    this.lName = this.userProfile?.last_name ? this.userProfile?.last_name : "";
  }

  public async handleSubmitCredentials() {
    const result = await dispatchUpdateUserProfile(this.$store, {
      email: this.userProfile?.email,
      first_name: this.fName,
      last_name: this.lName,
    });
    if (result) {
      // dispatchGetUserProfile(this.$store);
      this.$toast.success(this.$t("Saved successfully").toString());
    } else {
      this.$toast.error(this.$t("Failed to save").toString());
    }
    this.credentialsFormShow = false;
  }

  public handleChangeEmail() {
    this.emailFormShow = true;
  }

  // public handleChangeTelegram() {
  //   this.telegramFormShow = true;
  //   // @ts-ignore
  //   this.tgName = this.userProfile?.tg_username
  //     ? this.userProfile?.tg_username
  //     : "";
  // }

  public async handleGetTelegramRebindLink() {
    this.loadingRebind = true
    const response = await dispatchTelegramRebind(this.$store) as any;

    if (response instanceof Error || response?.response?.status >= 400) {
      this.telegramRebindLink = "";
      if (response?.response?.status === 400) {
        // active_telegram_required — показать UI как для not_linked
      }
      return;
    }

    this.telegramRebindLink = response?.data?.telegram_link ?? "";
    this.telegramRebindLinkExpired = response?.data?.expires_at ?? ""
    
    if (this.telegramRebindLink) {
      window.open(this.telegramRebindLink, '_blank');
    }
    this.loadingRebind = false
  }

  public connectNewBot() {
    window.open(this.userProfile?.telegramuser.telegram_link!!, "_blank");
  }

  public async handleSubmitChangeTelegram() {
    this.tgName = this.tgName.replace(/@/g, "");
    const result = await dispatchUpdateUserProfile(this.$store, {
      email: this.userProfile?.email,
      // tg_username: this.tgName,
    });
    if (result) {
      // dispatchGetUserProfile(this.$store);
      this.$toast.success(this.$t("Saved successfully").toString());
    } else {
      this.$toast.error(this.$t("Failed to save").toString());
    }
    // this.telegramFormShow = false;
  }

  public async handleChangeCheckbox() {
    const result = await dispatchUpdateUserProfile(this.$store, {
      email: this.userProfile?.email,
      show_contact_info: this.showСontactInfo,
    });
    if (result) {
      this.$toast.success(this.$t("Saved successfully").toString());
    } else {
      this.$toast.error(this.$t("Failed to save").toString());
    }
  }

  public async handleCheckTGConnect() {
    /**
     * 1. check connect
     * 2. show modal
     */
    const response = await dispatchTelegramConnectPreview(this.$store);
    if(response){
      this.preview = response.data;
      this.changeTGModalShow = true;
    }

  }

  
  /**this.userProfile &&
      this.userProfile.telegramuser &&
      this.userProfile?.telegramuser.telegram_link */
  public handleConnectBot() {
    if (
      this.userProfile &&
      this.userProfile.telegram &&
      this.userProfile?.telegram.connect_link
    ) {
      this.connectTelegramBotLoading = true;
      setTimeout(() => {
        dispatchGetUserProfile(this.$store);
      }, 5000);
      window.open(this.userProfile?.telegram.connect_link, "__blank");
    } else {
      this.$toast.error(this.$t("Failed").toString());
    }
    this.connectTelegramBotLoading = false;
  }

  public async handleDisableBot() {
    if (confirm(this.$t("Do you really want to disable bot?").toString())) {
      this.disableTelegramBotLoading = true;
      const result = await dispatchUnsubscribeFromBot(this.$store);

      if (result) {
        setTimeout(() => {
          dispatchGetUserProfile(this.$store);
        }, 5000);
        this.$toast.success(
          this.$t("Your subscription to Telegram bot has been successfully disabled").toString()
        );
      } else {
        this.$toast.error(this.$t("Failed to save").toString());
      }
      this.disableTelegramBotLoading = false;
    }
  }

  public handleLoadAvatar() {
    if (this.$refs.myFileInput) {
      // @ts-ignore
      this.$refs.myFileInput.click();
    }
  }

  public handleOpenAvatarModal() {
    this.avatarModalShow = true;
  }

  public handleCloseAvatarModal() {
    this.avatarModalShow = false;
  }

  public async handleChangeImage(event) {
    // this.imageFile = event.target.files ? event.target.files[0] : '';
    const formData = new FormData();
    formData.append("avatar", event.target.files ? event.target.files[0] : "");
    await dispatchUpdateUserAvatar(this.$store, formData);
    this.handleCloseAvatarModal();
  }

  public handleGoBack() {
    this.showResidentRules = false;
    // Удаляем query параметр из URL
    this.$router.replace({
      query: { ...this.$route.query, showRules: undefined },
    });
  }

  public handleBecomeResident() {
    this.showResidentRules = true;
    // Сохраняем состояние в query параметр URL
    this.$router.replace({
      query: { ...this.$route.query, showRules: "true" },
    });
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  get userProfileRole() {
    /**
     *
OLD_USER, NEW_USER, CLIENT, RESIDENT.
Изначально все текущие пользователи станут OLD_USER,
новые регистрации - NEW_USER,
после прохождения подтверждения все становятся RESIDENT.
     */
    return this.userProfile?.role;
  }

  get getImageUrl() {
    // if (!this.imageFile && this.userProfile && this.userProfile.avatar_165) {
    //   return `background-image: url(${this.userProfile.avatar_165});`;
    if (this.imageFile) {
      return URL.createObjectURL(this.imageFile);
    } else {
      return "";
    }
  }

  public extractBotName(url) {
    if (!url) return null;
    const regex = /t.me\/([a-zA-Z0-9_]+)/;
    const match = url.match(regex);
    return match ? `@${match[1]}` : null;
  }
}
